/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const DocumentFileSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24.5834 6L24.6672 6.00823C24.8572 6.04742 25 6.21771 25 6.42153V25.5781C25 25.7322 24.9172 25.8746 24.7836 25.9486C24.6499 26.0225 24.487 26.016 24.3588 25.9329L22.2318 23.3774L20.3855 25.9189C20.2392 26.027 20.0403 26.0269 19.894 25.9189L18.0794 23.4021L16.264 25.9189C16.1855 25.9768 16.0921 26.0023 15.9996 25.9979C15.9073 26.0021 15.8142 25.9766 15.736 25.9189L13.9173 23.4021L12.1076 25.9189C11.9613 26.0271 11.7626 26.027 11.6162 25.9189L9.76742 23.3774L7.6412 25.9329C7.51298 26.016 7.35007 26.0225 7.21645 25.9486C7.08287 25.8746 7 25.7321 7 25.5781V6.42153L7.00814 6.33673C7.0469 6.14454 7.21521 6 7.41662 6H24.5834ZM7.83324 24.5958L9.55829 22.513L9.61444 22.4825C9.74903 22.4221 9.90713 22.4373 10.0286 22.527L11.8611 25.0561L13.6724 22.541L13.7294 22.5056C13.8672 22.4346 14.035 22.4459 14.1631 22.5401L15.9996 25.0701L17.8345 22.5401L17.8915 22.5047C18.0293 22.434 18.1973 22.4459 18.3252 22.5401L20.1389 25.0561L21.9714 22.527C22.1102 22.4244 22.297 22.4191 22.4417 22.513L24.1668 24.5108V6.84305H7.83324V24.5958Z"
          fill="currentColor"
        />
        <path
          d="M21.2084 9.52941C21.4385 9.52941 21.625 9.71814 21.625 9.95094C21.625 10.1837 21.4385 10.3725 21.2084 10.3725H11.2096C10.9795 10.3725 10.7929 10.1837 10.7929 9.95094C10.7929 9.71814 10.9795 9.52941 11.2096 9.52941H21.2084Z"
          fill="currentColor"
        />
        <path
          d="M21.2084 12.784C21.4385 12.784 21.625 12.9727 21.625 13.2055C21.625 13.4383 21.4385 13.6271 21.2084 13.6271H11.2096C10.9795 13.6271 10.7929 13.4383 10.7929 13.2055C10.7929 12.9727 10.9795 12.784 11.2096 12.784H21.2084Z"
          fill="currentColor"
        />
        <path
          d="M21.2084 16.0386C21.4385 16.0386 21.625 16.2273 21.625 16.4601C21.625 16.6929 21.4385 16.8817 21.2084 16.8817H11.2096C10.9795 16.8817 10.7929 16.6929 10.7929 16.4601C10.7929 16.2273 10.9795 16.0386 11.2096 16.0386H21.2084Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}

export default DocumentFileSvg
